import { values as defaultBreakpoints } from '@mui/system/breakpoints';

const EQU = (input, bp) => input === bp;
const NEQ = (input, bp) => input !== bp;
const LEQ = (input, bp) => input <= bp;
const GTR = (input, bp) => input > bp;

const simulateBreakpointFns = (breakpoint) => {
  if (!breakpoint) return {};
  const order = Object.keys(defaultBreakpoints);
  const targetIndex = order.indexOf(breakpoint);
  const targetValue = defaultBreakpoints[breakpoint];
  const enable = (...keys) => `@media(min-width:0px) /*${keys.join('-')}*/`;
  const disable = '@media()';
  const compareToBreakpoint = (key, compareFn) => (
    typeof key === 'number' ? compareFn(key, targetValue) : compareFn(order.indexOf(key), targetIndex)
  );
  return {
    forceBreakpoint: breakpoint,
    breakpoints: {
      only: (key) => (compareToBreakpoint(key, EQU) ? enable('only', key) : disable),
      not: (key) => (compareToBreakpoint(key, NEQ) ? enable('not', key) : disable),
      up: (key) => (compareToBreakpoint(key, LEQ) ? enable('up', key) : disable),
      down: (key) => (compareToBreakpoint(key, GTR) ? enable('down', key) : disable),
      between: (keyA, keyB) => (
        compareToBreakpoint(keyA, LEQ) && compareToBreakpoint(keyB, GTR) ? enable('between', keyA, keyB) : disable
      ),
    },
  };
};

export default simulateBreakpointFns;
